<section class="playground">
  <h2 class="playground__heading">Filter fields</h2>
  <p class="playground__hint">
    <code>app-filter-text-field</code> y <code>app-filter-select-field</code> — <code>outline</code> fijo;
    <code>size</code>: <code>large</code> (40px) o <code>small</code> (32px). Tokens
    <code>filter-field-tokens.scss</code>. Figma:
    <a
      href="https://www.figma.com/design/nZEfdJ8pN0ILY9cAkO3DSG/Munily-UI-Kit-%7C-Design-system?node-id=9220-30384"
      target="_blank"
      rel="noopener noreferrer"
      >Text filter</a
    >,
    <a
      href="https://www.figma.com/design/nZEfdJ8pN0ILY9cAkO3DSG/Munily-UI-Kit-%7C-Design-system?node-id=9220-29999"
      target="_blank"
      rel="noopener noreferrer"
      >Select filter</a
    >. Estilos acotados a <code>app-filter-*</code> y <code>.munily-filter-select-panel</code>.
  </p>

  <div class="playground__grid">
    <div class="playground__controls">
      <label class="playground__field">
        <span>size</span>
        <select [(ngModel)]="size">
          <option *ngFor="let s of sizes" [value]="s">{{ s }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>widthLayout</span>
        <select [(ngModel)]="widthLayout">
          <option *ngFor="let w of widthLayouts" [value]="w">{{ w }}</option>
        </select>
      </label>
      <label class="playground__field">
        <span>maxWidth (opcional, ds)</span>
        <input type="text" [(ngModel)]="maxWidthCustom" placeholder="ej: 320px" />
      </label>
    </div>

    <div class="playground__preview">
      <p class="playground__preview-title">Filter text + filter select (toolbar)</p>
      <div class="playground__preview-row">
        <app-filter-text-field
          [size]="size"
          [widthLayout]="widthLayout"
          [maxWidth]="maxWidthCustom || undefined"
          [label]="textLabel"
          [placeholder]="textPlaceholder"
          [iconLeading]="textIcon || undefined"
          [control]="textControl"
        ></app-filter-text-field>
        <app-filter-select-field
          [size]="size"
          [widthLayout]="widthLayout"
          [maxWidth]="maxWidthCustom || undefined"
          [label]="selectLabel"
          [placeholder]="selectPlaceholder"
          [options]="selectOptions"
          [control]="selectControl"
          [clearValue]="selectEmptyValue"
        ></app-filter-select-field>
      </div>

      <p class="playground__preview-title">Validación (required)</p>
      <app-filter-text-field
        label="Requerido"
        [size]="size"
        [control]="requiredControl"
        [errorMessages]="{ required: 'Campo obligatorio' }"
      ></app-filter-text-field>
    </div>
  </div>
</section>
